import type { ViduV1LaneStats } from '@/app/services/vidu';
import type { UpdateInteractionStatusParams } from './community';

export type {
  ViduV1Activity as Activity,
  ViduV1ListActivitiesResponse,
  ViduV1WorkWithTask as WorkWithTask,
} from '@/app/services/vidu/types.gen';

/** 赛道类型（用于 sect-war 等活动） */
export type Lane = NonNullable<Exclude<ViduV1LaneStats['lane'], 'unspecified'>>;

/** 活动作品互动参数（支持灵感点赞） */
export type ActivityInteractionParams = UpdateInteractionStatusParams & {
  /** 活动 ID */
  activityId: string;
  /** 是否为灵感，如果是则使用灵感的点赞接口 */
  isInspiration?: boolean;
};

export enum ActivityType {
  Competition = 'competition',
  Regular = 'regular',
  Reward = 'reward',
  Other = 'other',
}
